import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

import {
  TradeStateContext,
  initialTradeStateContext
} from '../../contexts/trade';
import {
  PostTradeRejectAsync,
  PostTradeRequestOrConfirmAsync
} from '../../services/trade';
import { GameContext } from '../../contexts/game';
import { Avatar } from '@progress/kendo-react-layout';
import { deleteFromStore } from '../../utils/indexedDB';

export const TradeNotificationDialog = () => {
  const [game] = React.useContext(GameContext);
  const [trade, setTrade] = React.useContext(TradeStateContext);

  const playerList = game.gameState?.players ?? [];
  const requester = playerList.find((p) => p.code === trade.offerPlayerCode);

  const onDecline = async () => {
    if (game.gameCode) {
      try {
        await PostTradeRejectAsync(game.gameCode, String(trade.id));
        setTrade(initialTradeStateContext);
        deleteFromStore('trade', game.gameCode);
      } catch (error) {
        console.log(error, '>>>error when decline trade');
      }
    }
  };

  const onConfirm = async () => {
    if (game.gameCode) {
      try {
        await PostTradeRequestOrConfirmAsync(game.gameCode, 'confirm', {
          offerPlayerCode: trade.offerPlayerCode,
          requestPlayerCode: trade.requestPlayerCode
        });
      } catch (error) {
        console.log(error, '>>>error when confirm trade');
      }
    }
  };

  return (
    <div className="trade-notification__mask">
      <div className="trade-body">
        <div className="rounded-circle position-relative bg-white h-9 w-9">
          <Avatar
            type={'image'}
            themeColor={'light'}
            className={`h-9 w-9 border border-5 p-2 border-success`}>
            <img
              src={requester?.avatarImage ?? ''}
              className={`h-9 w-9 rounded-circle`}
              alt={'Player Avatar'}
            />
          </Avatar>
        </div>
        <span>{requester?.name ?? ''} would like to trade with you.</span>
        <div className="d-flex gap-2">
          <Button
            fillMode={'outline'}
            themeColor={'primary'}
            onClick={onDecline}>
            Decline
          </Button>
          <Button themeColor={'success'} onClick={onConfirm}>
            Start trading
          </Button>
        </div>
      </div>
    </div>
  );
};
